import React, { useState } from 'react';
import {
  Button, message, Modal, Spin, Table, Upload,
} from 'antd';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import axios from 'axios';
import Cookies from 'js-cookie';
import authStore from '@stores/auth';
import { storageKeys } from '@/constants';

const generateColumns = () => [
  {
    title: '错误行',
    dataIndex: 'row',
    key: 'row',
    width: 100,
    render: (text) => (text ? `第${text}行` : null),
  },
  {
    title: '错误信息',
    dataIndex: 'errorMsg',
    key: 'errorMsg',
  }];
const ImportButton = ({
  permissionKey, downloadTempUrl, downloadTempBtnName, importUrl, importBtnName, successCallback,
}) => {
  const columns = generateColumns();
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [errorData, setErrorData] = useState([]);

  // 导出数据请求
  const importDataRequest = async ({ file }) => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append('file', file);
      await axios({
        method: 'post',
        url: process.env.REACT_APP_API_ENDPOINT + importUrl,
        data: formData,
        timeout: 180000,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Device': 'pc',
          'X-User-Token': Cookies.get(storageKeys.token) || '',
        },
      }).then((res) => {
        if (res.data) {
          if (res.data.code === 0) {
            message.success('导入成功');
            successCallback();
          } else if (res.data.data) { // 导入失败并且有错误信息返回，则需要显示在界面上
            setErrorData(res.data.data);
            setVisible(true);
          } else {
            message.error(res.data.msg);
          }
        } else {
          message.error('上传失败');
        }
      });
    } catch (e) {
      message.error(e.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onClose = () => {
    setVisible(false);
  };

  if (permissionKey !== '' && authStore.permissions.indexOf(permissionKey) === -1) {
    return '';
  }
  return (
    <Spin spinning={isLoading}>
      <a href={downloadTempUrl}><Button icon={<DownloadOutlined />} style={{ marginRight: 20 }}>{downloadTempBtnName}</Button></a>
      <Upload name="file" accept=".xlsx,.xls" showUploadList={false} customRequest={importDataRequest}>
        <Button type="primary" ghost icon={<UploadOutlined />}>{importBtnName}</Button>
      </Upload>
      <Modal
        title="导入错误信息"
        visible={visible}
        width={900}
        onCancel={onClose}
        footer={null}
        maskClosable={false}
      >
        <Table
          bordered
          size="small"
          scroll={{
            x: 800,
            y: 400,
          }}
          pagination={false}
          rowKey={(record) => record.row}
          columns={columns}
          dataSource={errorData}
        />
      </Modal>
    </Spin>
  );
};

ImportButton.propTypes = {
  permissionKey: PropTypes.string, // 按钮所需权限
  downloadTempUrl: PropTypes.string.isRequired, // 导入模板
  downloadTempBtnName: PropTypes.string, // 导入模板按钮名称
  importUrl: PropTypes.string.isRequired, // 导入请求的URL
  importBtnName: PropTypes.string, // 导入按钮名称
  successCallback: PropTypes.func, // 导入成功的回调函数
};
ImportButton.defaultProps = {
  permissionKey: '',
  downloadTempBtnName: '导入模板下载',
  importBtnName: '导入',
  successCallback() {
    console.info('导入成功');
  },
};

export default ImportButton;
